import {
  StyleRulesCallback,
  WithStyles,
  withStyles as withStylesCb
} from "@material-ui/core/styles";

import { getHeaderMinHeight } from "../../helpers";

export const styles: StyleRulesCallback = ({ spacing, palette, shadows }) => ({
  header: {
    "&$withResume": {
      minHeight: 1
    },
    marginBottom: spacing.unit,
    minHeight: getHeaderMinHeight(spacing.unit)
  },
  withBreadcrumbs: {
    "&$withResume": {
      paddingTop: spacing.unit
    },
    paddingTop: spacing.unit
  },
  withResume: {
    backgroundColor: palette.common.white,
    borderBottomLeftRadius: "100% 30px",
    borderBottomRightRadius: "100% 30px",
    boxShadow: shadows[3],
    marginBottom: spacing.unit * 6,
    paddingBottom: spacing.unit * 6,
    paddingTop: spacing.unit * 6
  }
});

export type Styles = WithStyles<typeof styles>;
export const withStyles = withStylesCb(styles);
